import { useState, useEffect } from 'react';

/** System motion preference and the user's persistent accessibility pause setting. */
const readMotionPreference = () => typeof window !== 'undefined' && (
    window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ||
    document.documentElement.classList.contains('a11y-pause-animations')
);

export function useReducedMotion(): boolean {
  const [paused, setPaused] = useState(readMotionPreference);

  useEffect(() => {
    const mq = window.matchMedia?.('(prefers-reduced-motion: reduce)');
    const update = () => setPaused(readMotionPreference());
    mq?.addEventListener('change', update);
    const observer = new MutationObserver(update);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    update();
    return () => { mq?.removeEventListener('change', update); observer.disconnect(); };
  }, []);

  return paused;
}
